import type { AssessmentListParams } from '@/features/assessments/api/assessment-list'

export const assessmentKeys = {
  all: ['assessments'] as const,
  lists: () => [...assessmentKeys.all, 'list'] as const,
  list: (params: AssessmentListParams) => [...assessmentKeys.lists(), params] as const
}

export const hubspotSearchKeys = {
  all: ['hubspotSearch'] as const,
  searches: () => [...hubspotSearchKeys.all, 'search'] as const,
  search: (q: string, type?: 'deal' | 'plant') =>
    [...hubspotSearchKeys.searches(), q, type ?? 'all'] as const,
  plant: (hubspotId: string) => [...hubspotSearchKeys.all, 'plant', hubspotId] as const,
  deal: (hubspotId: string) => [...hubspotSearchKeys.all, 'deal', hubspotId] as const,
  duplicates: (params: { dealId?: string | null; plantId?: string | null }) =>
    [...hubspotSearchKeys.all, 'duplicates', params] as const
}
